import React from 'react';
import Loader from "../Loader";

function MovementCard(props) {
    const {isLoading, movements} = props;
    return (
        <div className="card facility-offloading">
            <div className="card-header">Offloading Status</div>
            <div className="card-body d-flex align-items-stretch">
                {isLoading ? <Loader size="2x"/> : ''}
                <React.Fragment>
                    <article className="simple-numeric">
                        <span className="label warn">Low Movement</span>
                        <strong>
                            {movements.low ? movements.low : 0}
                        </strong>
                        <span className="units">Residents</span>
                    </article>
                    <article className="simple-numeric">
                        <span className="label ok">Normal Movement</span>
                        <strong>
                            {movements.norm ? movements.norm : 0}
                        </strong>
                        <span className="units">Residents</span>
                    </article>
                    <article className="simple-numeric">
                        <span className="label warn">High Movement</span>
                        <strong>
                            {movements.high ? movements.high : 0}
                        </strong>
                        <span className="units">Residents</span>
                    </article>
                </React.Fragment>
            </div>
            <div className="card-footer">
                *Normal movement is 4–16 turns in each 4-hour period
            </div>
        </div>
    );
}

export default MovementCard;
